// @ts-strict-ignore
import * as React from 'react';
import Icon, {
    InfoCircleFilled,
    WarningFilled,
    ThunderboltFilled,
    QuestionCircleFilled,
    LockFilled,
} from '@ant-design/icons';
import Typography from 'antd/lib/typography';
import { antBlue, antGold, antGrey, runwayColors } from '../styles/globalStyles';
import Flex from 'antd/lib/flex';

export const setupModuleStyle: React.CSSProperties = {
    backgroundColor: antGrey.grey2,
    padding: '28px 36px',
    borderRadius: 8,
    border: `1px solid ${antGrey.grey5}`,
};

export const Tip: React.FC<{
    children: React.ReactNode;
    icon: typeof InfoCircleFilled;
    color: string;
}> = ({ children, icon, color }) => (
    <Flex gap={12} align="start">
        <Icon component={icon} style={{ fontSize: 16, color, marginTop: 3 }} />

        <Typography.Text style={{ color: antGrey.grey8, fontSize: 14, fontWeight: 400, flex: 1 }}>
            {children}
        </Typography.Text>
    </Flex>
);

export const InfoTip: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Tip color={antBlue.blue6} icon={InfoCircleFilled}>
        {children}
    </Tip>
);

export const WarningTip: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Tip color={runwayColors.statusYellow} icon={WarningFilled}>
        {children}
    </Tip>
);

export const AutomationTip: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Tip color={runwayColors.primary} icon={ThunderboltFilled}>
        {children}
    </Tip>
);

export const HelpTip: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Tip color={antGrey.grey6} icon={QuestionCircleFilled}>
        {children}
    </Tip>
);

export const SecureTip: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Tip color={antGold.gold7} icon={LockFilled}>
        {children}
    </Tip>
);
